<!-- 首页 -->
<template>
  <div class="box">
    <div ref="mapbox" class="mapbox"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/map/js/china.js";
// import jsonp from "jsonp";
const option = {
  title: {
    text: "全国共享人数分布",
    textStyle:{
       fontSize: 13
    },
    //  textStyle:{
    //    fontSize: 14,
    //    color:'#333333',
    //   //  bootom:18
    //  } 
    top:-5,
    // subtext: "仅供参考"
  },
  series: [
    {
      name: "共享人数",
      type: "map",
      map: "china",
      top:30,
      label: {
        show: true,
        color: "#000",
        fontSize: 10
      },
      // roam: true,
      zoom: 1.2,
      emphasis: {
        label: {
          color: "#fff",
          fontSize: 12
        },
        itemStyle: {
          areaColor: "#83b5e7"
        }
      }
    }
  ],
  data: [],
  visualMap: [
    {
      type: "piecewise",
      show: true,
      pieces: [
        { min: 10000 },
        { min: 1000, max: 9999 },
        { min: 100, max: 999 },
        { min: 10, max: 99 },
        { min: 1, max: 9 },
        { max: 0 }
      ],
      inRange: {
        symbol: "rect",
        color: ["#eee", "#5187CA"]
      },
      itemWidth: 20,
      itemHeight: 10,
      top:220,
    
    }
  ],
  tooltip: {
    trigger: "item"
  },
  // toolbox: {
  //   show: true,
  //   orient: "vertical",
  //   left: "right",
  //   top: "center",
  //   feature: {
  //     dataView: { readOnly: false },
  //     restore: {},
  //     saveAsImage: {}
  //   }
  // }
};
export default {
  data() {
    return {};
  },

  components: {},
  mounted() {
    this.mychart = echarts.init(this.$refs.mapbox);
    this.mychart.setOption(option);
    this.getData();
    window.addEventListener("resize", () => {
      this.mychart.resize();
    });
  },
  methods: {
    getData() {
      console.log("ssss",this.listMap)
      let list = this.listMap.map(item => ({
        name: item.name,
        value: item.value
      }));
      option.series[0].data = list;
      this.mychart.setOption(option);
      // jsonp(
      //   "https://interface.sina.cn/news/wap/fymap2020_data.d.json?_=1580892522427",
      //   {},
      //   (err, data) => {
      //     console.log("111",data)
      //     if (!err) {
      //       // console.log(data)
      //       let list = data.data.list.map(item => ({
      //         name: item.name,
      //         value: item.value
      //       }));
      //       option.series[0].data = list;
      //       this.mychart.setOption(option);
      //     }
      //   }
      // );
    }
  },
  props: {
    listMap: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style>
.mapbox {
  height:300px;
  width: 90%;
  background-color: #fff;
  margin:25px auto 20px
}
.box {
  display: flex;
  background-color: #fff;
  margin-bottom:10px
}
</style>
